<div id="tour-legend" class="pro-legend">
  <div>
    <div class="pro-legend__title">Legend</div>
    <div class="pro-legend__item">
      <div class="legend-color" [style.color]="institutionColor + ' !important'"></div>
      <div class="legend-text">
        {{ institution().name }}
      </div>
    </div>
    @if (peerName()) {
    <div class="pro-legend__item">
      <div class="legend-color" [style.color]="peerColor + ' !important'"></div>
      <div class="legend-text">
        {{ peerName() }}
      </div>
    </div>
    }
    @if (rate()) {
    <div class="pro-legend__item">
      <div class="legend-color" [style.color]="rateColor + ' !important'"></div>
      <div class="legend-text" [style.color]="institutionColor + ' !important'">
        {{ rate()?.rateName }}
      </div>
    </div>
    }
  </div>
</div>
